import './App.css';
import React, { useState, useEffect } from 'react'
import {BrowserRouter, Routes, Route } from 'react-router-dom'
import { onAuthStateChanged } from 'firebase/auth'

import { ProtectedRoute } from "./component/protectedRoute"

import {Home} from './pages/home'
import { Private } from './pages/private'
import { auth } from './firebase-config'

const App = () => {
  const [user, setUser] = useState(null)
  const [isFetching, setIsFetching] = useState(true)

  useEffect(()=>{
    const unsub = onAuthStateChanged(auth, (user)=>{
      if(user){
        setUser(user)
        setIsFetching(false)
        return;
      }
      else{
        setUser(null)
        setIsFetching(false)
      }
    })
    return () => unsub()
  }, [])

  if(isFetching){
    return <h1>Loading...</h1>
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route index path ='/' element={<Home user={user}></Home>}/>
        <Route path ='/private' element={
          <ProtectedRoute user={user}>
            <Private></Private>
          </ProtectedRoute>
        }/>

      </Routes>
    </BrowserRouter>
  )
}

export default App